import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useSEO, getOrganizationSchema, getBreadcrumbSchema } from '../../utils/seo';

export default function Services() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Hukuk Hizmetlerimiz Isparta Avukat Yıldız & Başyiğit',
    description: 'Isparta Yıldız & Başyiğit Hukuk Bürosu olarak ticaret ve şirketler hukuku, gayrimenkul ve inşaat hukuku, iş hukuku ve sosyal güvenlik, ceza hukuku, icra ve iflas hukuku, sözleşmeler hukuku, aile hukuku, idare ve vergi hukuku, tazminat hukuku, kişisel verilerin korunması ve miras hukuku alanlarında profesyonel hukuki danışmanlık hizmetleri sunuyoruz.',
    keywords: 'hukuk hizmetleri Isparta, ticaret hukuku, gayrimenkul hukuku, iş hukuku, ceza hukuku, aile hukuku',
    ogImage: 'https://public.readdy.ai/ai/img_res/3aa912135b0830dff39739c3881fc4f8.jpg',
    canonical: `${siteUrl}/services`,
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        getOrganizationSchema(),
        getBreadcrumbSchema([
          { name: 'Ana Sayfa', url: siteUrl },
          { name: 'Hizmetler', url: `${siteUrl}/services` }
        ]),
        {
          '@type': 'ItemList',
          itemListElement: [
            {
              '@type': 'Service',
              position: 1,
              name: 'Ticaret ve Şirketler Hukuku',
              description: 'Şirket kuruluşu, birleşme, devir işlemleri ve ticari uyuşmazlıklar'
            },
            {
              '@type': 'Service',
              position: 2,
              name: 'Gayrimenkul ve İnşaat Hukuku',
              description: 'Tapu işlemleri, kira sözleşmeleri ve inşaat uyuşmazlıkları'
            },
            {
              '@type': 'Service',
              position: 3,
              name: 'İş Hukuku ve Sosyal Güvenlik',
              description: 'İşçi-işveren ilişkileri, iş sözleşmeleri ve sosyal güvenlik hakları'
            }
          ]
        }
      ]
    }
  });

  const services = [
    {
      id: 'ticaret-sirketler-hukuku',
      title: 'Ticaret ve Şirketler Hukuku',
      description: 'Şirket kuruluşu, ortaklık anlaşmaları, ticari sözleşmeler, birleşme ve devir işlemleri.',
      icon: 'ri-building-line',
      features: ['Şirket Kuruluşu', 'Ortaklık Anlaşmaları', 'Birleşme ve Devir', 'Ticari Sözleşmeler']
    },
    {
      id: 'gayrimenkul-insaat-hukuku',
      title: 'Gayrimenkul ve İnşaat Hukuku',
      description: 'Tapu işlemleri, kira sözleşmeleri, emlak alım-satımı, inşaat sözleşmeleri ve uyuşmazlıkları.',
      icon: 'ri-home-line',
      features: ['Tapu İşlemleri', 'İnşaat Sözleşmeleri', 'Emlak Uyuşmazlıkları', 'Kiralama İşlemleri']
    },
    {
      id: 'is-hukuku-sosyal-guvenlik',
      title: 'İş Hukuku ve Sosyal Güvenlik',
      description: 'İş sözleşmeleri, işçi hakları, işten çıkarma, SGK işlemleri ve iş kazası tazminatları.',
      icon: 'ri-briefcase-line',
      features: ['İş Sözleşmeleri', 'SGK İşlemleri', 'İşçilik Alacağı Davaları', 'Hizmet Tespit Davaları']
    },
    {
      id: 'ceza-hukuku',
      title: 'Ceza Hukuku',
      description: 'Ceza Hukuku kapsamında tüm dava türleri ile ilgilenilmektedir.',
      icon: 'ri-scales-3-line',
      features: ['Suç Davaları', 'Savunma Stratejileri', 'Hukuki Temsil', 'Ceza Davası Takibi']
    },
    {
      id: 'icra-iflas-hukuku',
      title: 'İcra ve İflas Hukuku',
      description: 'İcra takipleri, haciz işlemleri, iflas davaları ve alacak tahsilatı süreçleri.',
      icon: 'ri-file-list-3-line',
      features: ['İcra Takipleri', 'Haciz İşlemleri', 'Alacak Tahsilatı', 'İflas Davaları']
    },
    {
      id: 'sozlesmeler-hukuku',
      title: 'Sözleşmeler Hukuku',
      description: 'Sözleşme hazırlama, müzakere, ihlal davaları ve sözleşmeli uyuşmazlık çözümü.',
      icon: 'ri-file-text-line',
      features: ['Sözleşme Hazırlama', 'Müzakere Süreçleri', 'İhlal Davaları', 'Hukuki Danışmanlık']
    },
    {
      id: 'aile-hukuku',
      title: 'Aile Hukuku',
      description: 'Boşanma, velayet, nafaka, mal paylaşımı, evlat edinme ve aile içi hukuki sorunlar.',
      icon: 'ri-heart-line',
      features: ['Boşanma Davaları', 'Velayet İşleri', 'Mal Rejimi Davaları', 'Ziynet Alacağı Davaları']
    },
    {
      id: 'idare-vergi-hukuku',
      title: 'İdare ve Vergi Hukuku',
      description: 'İdari davalar, vergi uyuşmazlıkları, kamu ihaleleri ve idari yaptırım davaları.',
      icon: 'ri-government-line',
      features: ['İdari Davalar', 'Vergi Uyuşmazlıkları', 'Kamu İhaleleri', 'İdari Yaptırımlar']
    },
    {
      id: 'tazminat-hukuku',
      title: 'Tazminat Hukuku',
      description: 'Maddi ve manevi tazminat davaları, trafik ve iş kazası tazminatları.',
      icon: 'ri-money-dollar-circle-line',
      features: ['Maddi Tazminat', 'Manevi Tazminat', 'Trafik Kazasından Kaynaklı Tüm Tazminat Talepleri', 'İş Kazasından Kaynaklı Tüm Tazminat Talepleri']
    },
    {
      id: 'kisisel-verilerin-korunmasi',
      title: 'Kişisel Verilerin Korunması Hukuku',
      description: 'Kişisel Verilerin Korunması Hukuku alanında danışmanlık hizmeti vermekteyiz.',
      icon: 'ri-shield-user-line',
      features: ['KVKK Uyum', 'Veri Güvenliği', 'Hukuki Danışmanlık', 'Mevzuat Uyumu']
    },
    {
      id: 'miras-hukuku',
      title: 'Miras Hukuku',
      description: 'Miras paylaşımı, veraset işlemleri, miras davaları ve miras hukuku danışmanlığı.',
      icon: 'ri-ancient-gate-line',
      features: ['Miras Paylaşımı', 'Mirasın Reddi', 'Veraset ve İntikal İşlemleri', 'İzale-i Şüyu Davaları']
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-slate-900 text-white py-20">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20law%20office%20interior%20with%20modern%20legal%20books%2C%20elegant%20wooden%20shelves%2C%20sophisticated%20lighting%2C%20clean%20minimalist%20design%2C%20corporate%20legal%20environment%2C%20high-quality%20photography%2C%20dark%20and%20professional%20atmosphere%2C%20justice%20scales%20and%20legal%20documents&width=1920&height=600&seq=services-hero-main&orientation=landscape')`
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 to-slate-900/70"></div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 animate-fade-in-up font-poppins">
            Hizmetlerimiz
          </h1>
          <div className="w-24 h-1 bg-white mx-auto mb-6"></div>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto animate-fade-in-up font-poppins font-light" style={{ animationDelay: '0.2s' }}>
            Geniş hukuki uzmanlık alanlarımızda profesyonel danışmanlık ve temsil hizmetleri sunuyoruz
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 animate-fade-in-up font-poppins">
              Uzmanlık Alanlarımız
            </h2>
            <div className="w-16 h-0.5 bg-slate-900 mx-auto mb-6"></div>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto animate-fade-in-up font-poppins font-light" style={{ animationDelay: '0.1s' }}>
              Her hukuk alanında deneyimli kadromuzla size en iyi hizmeti sunmaya hazırız
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={service.id}
                className="bg-white rounded-lg shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 group animate-fade-in-up hover-lift"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="p-8">
                  <div className="w-16 h-16 bg-slate-900 rounded-lg flex items-center justify-center mb-6 group-hover:bg-slate-800 transition-colors">
                    <i className={`${service.icon} text-2xl text-white`}></i>
                  </div>
                  
                  <h3 className="text-xl font-bold text-slate-900 mb-4 font-poppins">
                    {service.title}
                  </h3>
                  
                  <p className="text-slate-600 mb-6 leading-relaxed font-poppins font-light">
                    {service.description}
                  </p>
                  
                  <ul className="space-y-2 mb-6">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center text-sm text-slate-600 font-poppins font-light">
                        <i className="ri-check-line text-slate-900 mr-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  
                  <Link
                    to={`/services/${service.id}`}
                    className="inline-flex items-center text-slate-900 font-semibold hover:text-slate-700 transition-colors group-hover:translate-x-1 transform duration-200 font-poppins whitespace-nowrap cursor-pointer"
                  >
                    Detayları Görüntüle
                    <i className="ri-arrow-right-line ml-2"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div className="animate-fade-in-up">
              <div className="text-4xl font-bold text-slate-900 mb-2 font-poppins">4+</div>
              <div className="text-slate-600 font-poppins font-light">Yıl Deneyim</div>
            </div>
            <div className="animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
              <div className="text-4xl font-bold text-slate-900 mb-2 font-poppins">500+</div>
              <div className="text-slate-600 font-poppins font-light">Başarılı Dava</div>
            </div>
            <div className="animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
              <div className="text-4xl font-bold text-slate-900 mb-2 font-poppins">11</div>
              <div className="text-slate-600 font-poppins font-light">Uzmanlık Alanı</div>
            </div>
            <div className="animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
              <div className="text-4xl font-bold text-slate-900 mb-2 font-poppins">%98</div>
              <div className="text-slate-600 font-poppins font-light">Müvekkil Memnuniyeti</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-slate-900 mb-4 animate-fade-in-up font-poppins">
            Hukuki Danışmanlığa İhtiyacınız mı Var?
          </h2>
          <p className="text-lg text-slate-600 mb-8 animate-fade-in-up font-poppins font-light" style={{ animationDelay: '0.1s' }}>
            Uzman avukat kadromuzla size en uygun çözümü sunmaya hazırız
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <button 
              onClick={() => {
                const appointmentButton = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
                if (appointmentButton) {
                  appointmentButton.click();
                } else {
                  // Fallback: scroll to header and trigger appointment modal
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                  setTimeout(() => {
                    const headerButton = document.querySelector('[data-appointment-trigger]') as HTMLElement;
                    if (headerButton) headerButton.click();
                  }, 500);
                }
              }}
              className="bg-slate-900 text-white px-8 py-3 rounded-lg hover:bg-slate-800 transition-colors font-poppins font-semibold whitespace-nowrap cursor-pointer"
            >
              Ücretsiz Konsültasyon
            </button>
            <Link
              to="/contact"
              className="border border-slate-900 text-slate-900 px-8 py-3 rounded-lg hover:bg-slate-900 hover:text-white transition-colors font-poppins font-semibold whitespace-nowrap cursor-pointer inline-block text-center"
            >
              İletişime Geç
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
